module.exports = __webpack_public_path__ + "img/xpu-ha-resort.a86ee2ee.jpg";